export default __webpack_public_path__ + "static/media/Polimet-500-ban.6dd549c7.jpg";